import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "border pr-3 pl-4 py-1 mb-2 flex text-red-600 border-red-400 bg-red-100 dark:text-dark-text dark:border-red-900 dark:bg-red-900",
  style: {"user-select":"contain","border-radius":"1rem"}
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-xl pr-3" }, "error", -1)
const _hoisted_4 = { class: "w-full my-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-xl" }, " close ", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.text), 1),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "focus:outline-none",
          style: {"user-select":"none"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
        }, _hoisted_6)
      ])
    ])
  ]))
}